// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"e20630b9","225":"ec2a8bac","493":"92756b0a","539":"8df8893f","540":"19ca94fa","597":"5eee04b5","708":"a0fe6420","746":"11e6b33a","773":"c7bc853a","839":"a7a9486a","886":"e2fc3ca7","966":"2181cc8e"}[chunkId] + ".chunk.js";
};